import { CompanyInfosProvider } from '@hellodarwin/core/lib/features/providers/company-infos-provider';
import React, { PropsWithChildren } from 'react';
import { useAppSelector } from '../../app/app-hooks';
import { selectCompany, selectContact, selectProfile } from '../api/slices/profile-slice';

/**
 * Wrapper component that connects Redux state to CompanyInfosProvider
 */
const CompanyInfosProviderWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const profile = useAppSelector(selectProfile);
  const company = useAppSelector(selectCompany);
  const contact = useAppSelector(selectContact);

  return (
    <CompanyInfosProvider
      profile={profile}
      company={company}
      contacts={!!contact ? [contact] : []}
    >
      {children}
    </CompanyInfosProvider>
  );
};

export default CompanyInfosProviderWrapper;
